function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3248_186)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.01558 13.6008C5.91237 13.2157 6.13432 12.8312 6.51948 12.728C6.89163 12.6283 7.28431 12.855 7.38347 13.2269L9.25393 20.2075L17.6854 5.6038C17.8819 5.26337 18.3138 5.14021 18.6542 5.33676C18.9947 5.5333 19.1127 5.97398 18.9162 6.31441L10.4847 20.9181L17.4571 19.0429C17.8375 18.9479 18.2308 19.175 18.3299 19.5468C18.4331 19.932 18.2112 20.3164 17.826 20.4196L9.19283 22.7328C8.82068 22.8326 8.428 22.6058 8.32884 22.234L6.01558 13.6008Z",
  fill: "#FF5F7B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3248_186"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0 17.6602) rotate(-60)"
})));

var SvgDebit = function SvgDebit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDebit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/debit.983080f3.svg";
export { ForwardRef as ReactComponent };